import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-radio-group-gap: var(--sds-radio-group-gap, var(--sds-spacing-xs));
		--_sds-radio-group-row-gap: var(--sds-radio-group-row-gap, var(--sds-spacing-md));
		--_sds-radio-group-font-family: var(--sds-radio-group-font-family, var(--sds-typography-font-family-roboto));
		--_sds-radio-group-font-size: var(--sds-radio-group-font-size, var(--sds-components-font-size-content-md));
		--_sds-radio-group-text-color: var(--sds-radio-group-text-color, var(--sds-color-text-default, var(--sds-color-neutral-text-default)));
		--_sds-radio-group-max-line-width: var(--sds-radio-group-max-line-width, var(--sds-typography-max-line-width));
		--_sds-radio-group-disabled-opacity: var(--sds-radio-group-disabled-opacity, var(--sds-color-states-disabled-opacity));

		--_sds-radio-group-legend-font-weight: var(--sds-radio-group-legend-font-weight, var(--sds-typography-body-lg-strong-tall-desktop-font-weight));
		--_sds-radio-group-legend-line-height: var(--sds-radio-group-legend-line-height, var(--sds-components-line-height-squeezed-md));
		--_sds_radio-group-legend-help-text-gap: var(--sds-radio-group-legend-help-text-gap, var(--sds-spacing-4xs));

		--_sds-radio-group-help-text-color: var(--sds-radio-group-help-text-color, var(--sds-color-text-subtle, var(--sds-color-neutral-text-subtle)));
		--_sds-radio-group-help-text-font-size: var(--sds-radio-group-help-text-font-size, var(--sds-components-font-size-content-md));
		--_sds-radio-group-help-text-font-weight: var(--sds-radio-group-help-text-font-weight, var(--sds-typography-body-md-desktop-font-weight));
		--_sds-radio-group-help-text-line-height: var(--sds-radio-group-help-text-line-height, var(--sds-components-line-height-squeezed-md));

		display: block;
		contain: layout style;
		box-sizing: border-box;
	}

	.sds-radio-group {
		border: 0;
		margin: 0;
		padding: 0;
		color: var(--_sds-radio-group-text-color);
		font-family: var(--_sds-radio-group-font-family);
		font-size: var(--_sds-radio-group-font-size);
	}

	.sds-radio-group--disabled {
		.sds-radio-group__legend,
		.sds-radio-group__help-text,
		sds-alert {
			opacity: var(--_sds-radio-group-disabled-opacity);
		}
	}

	sds-alert {
		--sds-alert-padding: 0px;
	}

	.sds-radio-group__legend {
		display: flex;
		align-items: center;
		gap: var(--sds-spacing-5xs);
		margin: 0;
		padding: 0;
		font-weight: var(--_sds-radio-group-legend-font-weight);
		line-height: var(--_sds-radio-group-legend-line-height);
		max-width: var(--_sds-radio-group-max-line-width);

		+ .sds-radio-group__help-text {
			margin-block-start: var(--_sds_radio-group-legend-help-text-gap);
		}
	}

	.sds-radio-group__help-text {
		margin: 0;
		color: var(--_sds-radio-group-help-text-color);
		font-size: var(--_sds-radio-group-help-text-font-size);
		font-weight: var(--_sds-radio-group-help-text-font-weight);
		line-height: var(--_sds-radio-group-help-text-line-height);
		max-width: var(--_sds-radio-group-max-line-width);
	}

	.sds-radio-group__radios {
		display: flex;
		flex-direction: column;
		gap: var(--_sds-radio-group-gap);
		margin-top: var(--_sds-radio-group-gap);

		&.sds-radio-group--row {
			flex-direction: row;
			gap: var(--_sds-radio-group-row-gap);
		}
	}

	sds-alert {
		margin-top: var(--_sds-radio-group-gap);
	}

	:host([size='sm']) {
		--_sds-radio-group-font-size: var(--sds-radio-group-font-size, var(--sds-components-font-size-content-sm));
		--_sds-radio-group-legend-line-height: var(--sds-radio-group-legend-line-height, var(--sds-components-line-height-squeezed-sm));
		--_sds-radio-group-help-text-font-size: var(--sds-radio-group-help-text-font-size, var(--sds-components-font-size-content-sm));
		--_sds-radio-group-help-text-line-height: var(--sds-radio-group-help-text-line-height, var(--sds-components-line-height-squeezed-sm));
	}

	:host([size='lg']) {
		--_sds-radio-group-font-size: var(--sds-radio-group-font-size, var(--sds-components-font-size-content-lg));
		--_sds-radio-group-legend-line-height: var(--sds-radio-group-legend-line-height, var(--sds-components-line-height-squeezed-lg));
		--_sds-radio-group-help-text-font-size: var(--sds-radio-group-help-text-font-size, var(--sds-components-font-size-content-lg));
		--_sds-radio-group-help-text-line-height: var(--sds-radio-group-help-text-line-height, var(--sds-components-line-height-squeezed-lg));
	}
`;
